module.exports = __webpack_public_path__ + "img/term.b3633912.png";